const { REACT_APP_REST_HOST } = process.env;

const host=REACT_APP_REST_HOST || 'https://vps.urwick.co.uk:8443'

export function backendFetch(uri) {
	return fetch(`${host}/rest/${uri}`)
			.then(response => response.json())
			.catch(()=>{throw new Error(`backendFetch failed: ${uri}`)});
}

// TODO: should refactor this, lots of common code with below
export async function backendPostJsonWithResult(token,dropAdmin,uri,object,method='POST') {
	const response = await fetch(`${host}/rest/${uri}${token?`?token=${token}`:''}`, {
		method: method,
		headers: {
			'Content-type': 'application/json'
		},
		body: JSON.stringify(object)
	});
	if (response.ok) {
		return response.json();
	} else {
		console.log(response);
		if (response.status===401 && dropAdmin)	// Forbidden, token expired
			dropAdmin();
		return undefined;
	}
}

export async function backendPostWithJson(token,dropAdmin,uri,object,method='POST') {
	const response = await fetch(`${host}/rest/${uri}?token=${token}`, {
		method: method,
		headers: {
			'Content-type': 'application/json'
		},
		body: JSON.stringify(object)
	});
	if (response.ok) {
		return true;
	} else {
		console.log(response);
		if (response.status===401)	// Forbidden, token expired
			dropAdmin();
		return false;
	}
}

export async function backendPutWithJson(token,dropAdmin,uri,object) {
	return backendPostWithJson(token,dropAdmin,uri,object,'PUT');
}

export function backendAuthenticate(username,password) {
	return fetch(`${host}/rest/auth/login`,{
		method: 'POST',
		headers: {
			'Content-type': 'application/json'
		},
		body: JSON.stringify({
			username,
			password
		})
	}).then((response) => {
		if (response.ok) {
			return response.json();
		} else {
			return null;
		}
	}).catch(()=>{throw new Error("backendAuthenticate failed")});
}

export function backendCheckToken(token) {
	return fetch(`${host}/rest/auth/check?token=${token}`)
		.then(response => response.ok)
		.catch(()=>{throw new Error("backendCheckToken failed")})
}